import { Box } from "rizzui/box";
import cn from "../../lib/utils/class-name";
import Ring from "../../assets/ring";
import Bar from "../../assets/bar";
import { Text } from "rizzui/typography";

export type Steps = {
  title: string;
  subtitle: string;
  pageId: string;
};

export default function MultiStep({
  data,
  currentPage,
  customWidth,
}: {
  data: Steps[];
  currentPage: string;
  customWidth?: string;
}) {
  return (
    <Box className="hidden xl:flex z-[5] ml-[150px] gap-[16px] min-w-[215px] w-auto h-[238px]">
      <div>
        {data.map((link, i) => {
          const isLast = data.length === i + 1;
          const page = data.findIndex((link) => link.pageId === currentPage);
          const fill = page >= i ? "text-[#1FB6FF]" : "text-[#D9D9D9]";
          return (
            <div
              key={link.title}
              className={cn("h-fit place-items-center -mb-[8px]", fill)}
            >
              <Ring className={""} key={link.subtitle} />
              {!isLast && <Bar className={"mt-[0px]"} />}
            </div>
          );
        })}
      </div>
      <div className={cn(customWidth)}>
        {data.map((link, i) => {
          return (
            <div className="flex flex-col gap-[4px] mb-[28px] mt-[0px]">
              <Text
                key={link.title}
                className="font-ibmPlexSerif text-[14px] leading-[18px] font-[500] text-primary-dark"
              >
                {link.title}
              </Text>
              <Text className="font-inter text-[12px] leading-[18px] font-[400] text-[#758599] -tracking-[0.01em]">
                {link.subtitle}
              </Text>
            </div>
          );
        })}
      </div>
    </Box>
  );
}
